import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { useTheme } from '../contexts/ThemeContext';

const ManagementModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  title, 
  children,
  submitButtonText = 'Save'
}) => {
  const { isDarkMode } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none p-4">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      
      {/* Modal Container */}
      <div className={`
        relative w-full max-w-md mx-auto my-auto 
        ${isDarkMode ? 'bg-gray-800 text-gray-200' : 'bg-white text-gray-800'}
        rounded-xl shadow-2xl
        max-h-[90vh] overflow-y-auto
      `}>
        {/* Modal Header */}
        <div className={`
          flex justify-between items-center p-5 sticky top-0 z-10
          ${isDarkMode ? 'bg-gray-800 border-b-gray-700' : 'bg-white border-b-gray-200'}
          border-b
        `}>
          <h3 className={`text-xl font-semibold ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}>
            {title}
          </h3>
          <button 
            onClick={onClose}
            className={`
              p-1 rounded-full 
              ${isDarkMode 
                ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700' 
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
              }
              transition
            `}
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
        
        {/* Modal Body */}
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          {children}
          
          {/* Modal Footer with Action Buttons */}
          <div className="flex justify-end space-x-3 pt-4 sticky bottom-0 bg-white dark:bg-gray-800 z-10">
            <button 
              type="button"
              onClick={onClose}
              className={`
                px-4 py-2 rounded-lg 
                ${isDarkMode 
                  ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }
                transition
              `}
            >
              Cancel
            </button>
            <button 
              type="submit"
              className={`
                px-4 py-2 rounded-lg 
                ${isDarkMode 
                  ? 'bg-blue-600 text-white hover:bg-blue-500' 
                  : 'bg-blue-500 text-white hover:bg-blue-600'
                }
                transition
              `}
            >
              {submitButtonText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManagementModal;
